import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import ExpandIcon from '../icons/ExpandIcon';
import { useLocation } from 'react-router-dom';
import MixpanelLogger from '_legacy/diagnostics/logging/mixpanelLogger';

interface OpenFullscreenTabButtonProps {
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    tooltip?: string;
    style?: React.CSSProperties;
    className?: string;
}

const OpenFullscreenTabButton = React.forwardRef<
    HTMLDivElement,
    OpenFullscreenTabButtonProps
>(({ onClick, tooltip = 'Open in new tab', style, className }, ref) => {
    const location = useLocation();

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();

        // Add ?fullscreen=1 to current location
        const params = new URLSearchParams(location.search);
        params.set('fullscreen', '1');
        const url = `${window.location.origin}${
            location.pathname
        }?${params.toString()}${location.hash}`;

        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

        if (newWindow) {
            newWindow.opener = null;
        }

        onClick?.(event);

        const vesselImo = location.pathname.split('/')?.[2];
        MixpanelLogger.trackOpenFortWithVesselFilter(vesselImo);
    };

    const button = (
        <div
            ref={ref}
            className={`toolbar-button ${className || ''}`}
            onClick={handleClick}
            style={style}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick(e as any);
                }
            }}
        >
            <ExpandIcon />
        </div>
    );

    return tooltip ? (
        <Tooltip placement="top" overlay={tooltip} trigger={['hover']}>
            {button}
        </Tooltip>
    ) : (
        button
    );
});

OpenFullscreenTabButton.displayName = 'OpenFullscreenTabButton';

export default OpenFullscreenTabButton;
